import React, { useEffect, useState } from "react";
import { Row, Col, InputGroup, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faMaximize,
  faMinimize,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { getToken } from "../utils/authUtils";
import axios from "axios";
import CatalogListModal from "../App/Components/CatalogListModal";

interface CatalogHeaderProps {
  searchQuery?: string;
  setSearchQuery?: (query: string) => void;
  showSearch?: boolean;
  showCatalogButton?: boolean;
  showFullscreenbutton?: boolean;
  isFullscreen?: boolean;
  onToggleFullscreen?: () => void;
  customButton?: React.ReactNode;
}

const CatalogHeader: React.FC<CatalogHeaderProps> = ({
  searchQuery = "",
  setSearchQuery = () => {},
  showSearch = true,
  showCatalogButton = true,
  showFullscreenbutton = false,
  onToggleFullscreen,
  isFullscreen,
  customButton,
}) => {
  const [organization, setOrganization] = useState<any>(null);
  // eslint-disable-next-line
  const [loadingOrganization, setLoadingOrganization] = useState<boolean>(true);
  const navigate = useNavigate();
  const [showCatalogModal, setShowCatalogModal] = useState(false);

  const handleback = () => {
    navigate(-1);
  };

  const getLogo = async () => {
    const userToken = getToken();
    setLoadingOrganization(true);

    const apiUrl = `${process.env.REACT_APP_API_URL}api/public/organizations`;
    console.log("API URL:", apiUrl);

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });

      if (response.status === 200 && response.data?.data) {
        setOrganization(response.data.data);
      } else {
        navigate("/");
      }
    } catch (error: any) {
      console.error("Error fetching organization logo:", error);
      if (error.response?.status === 404) {
        navigate("/");
      } else {
        navigate("/");
      }
    } finally {
      setLoadingOrganization(false);
    }
  };

  useEffect(() => {
    getLogo();
  }, []);

  const toggleCatalogModal = () => {
    setShowCatalogModal(!showCatalogModal);
  };

  return (
    <div className="see-catalog-header position-relative w-100 mt-0">
      <Row className="d-flex justify-content-between align-items-center w-100 m-0 mb-4">
        {showSearch ? (
          <React.Fragment>
            <Col
              xs={12}
              md={7}
              className="d-flex justify-content-between align-items-center my-2 my-md-0"
            >
              <button
                className="uniform-back-btn btn btn-sm"
                onClick={handleback}
              >
                <FontAwesomeIcon
                  icon={faArrowLeft}
                  style={{
                    color: "#FFFFFF",
                    height: "15.57px",
                    width: "15.99px",
                  }}
                />
              </button>

              {organization && organization.logo ? (
                <img
                  src={organization.logo}
                  alt="Logo"
                  className="img-fluid header-logo-catalog"
                />
              ) : (
                <div className="skeleton-catalog header-logo-catalog"></div>
              )}
            </Col>
            <Col
              xs={12}
              md={5}
              className="d-flex justify-content-end my-2 my-md-0"
            >
              <div className="d-flex align-items-center me-4">
                <button
                  type="button"
                  className="btn btn-sm uniform-back-btn d-flex align-items-center justify-content-center"
                  onClick={toggleCatalogModal}
                >
                  <img
                    src="/icon/download-img.svg"
                    alt=""
                    height="16.32px"
                    width="22.59px"
                  />
                </button>
              </div>

              <div className="d-flex align-items-center justify-content-end custom-width bg-transparent">
                <InputGroup
                  className="w-100"
                  style={{ borderRadius: "8px", border: "0.5px solid #fff" }}
                >
                  <InputGroup.Text className="uniform-back-btn border-0 custom-search-icon">
                    <FontAwesomeIcon
                      icon={faSearch}
                      style={{
                        color: "white",
                        height: "18.04px",
                        width: "18.04px",
                      }}
                    />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search Tile....."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="custom-search"
                  />
                </InputGroup>
              </div>
            </Col>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Col
              xs={7}
              md={7}
              className=" d-flex justify-content-between align-items-center"
            >
              <button
                className="btn btn-sm uniform-back-btn me-2"
                onClick={handleback}
              >
                <FontAwesomeIcon
                  icon={faArrowLeft}
                  style={{
                    color: "#FFFFFF",
                    height: "15.57px",
                    width: "15.99px",
                  }}
                />
              </button>
              {organization && organization.logo ? (
                <img
                  src={organization.logo}
                  alt="Logo"
                  className="img-fluid header-logo-catalog"
                />
              ) : (
                <div className="skeleton-catalog header-logo-catalog"></div>
              )}
            </Col>
            <Col
              xs={5}
              md={5}
              className="d-flex justify-content-end my-2 my-md-0"
            >
              {showCatalogButton && (
                <button
                  type="button"
                  className="btn btn-sm uniform-back-btn d-flex align-items-center justify-content-center"
                  onClick={toggleCatalogModal}
                >
                  <img
                    src="/icon/download-img.svg"
                    alt=""
                    height="16.32px"
                    width="22.59px"
                  />
                </button>
              )}
              {showFullscreenbutton && onToggleFullscreen && (
                <button
                  type="button"
                  className="btn btn-sm uniform-back-btn d-flex align-items-center justify-content-center"
                  onClick={onToggleFullscreen}
                >
                  <FontAwesomeIcon
                    icon={isFullscreen ? faMinimize : faMaximize}
                    style={{ color: "#FFFFFF", height: "20px", width: "20px" }}
                    title={isFullscreen ? "Minimize" : "Maximize"}
                  />
                </button>
              )}
              {customButton && <div className="ms-2">{customButton}</div>}{" "}
            </Col>
          </React.Fragment>
        )}
        <CatalogListModal
          showCatalogModal={showCatalogModal}
          closeCatalogModal={toggleCatalogModal}
        />
      </Row>
    </div>
  );
};

export default CatalogHeader;
